import { CoreIcon } from '../core-icon';
import arrowRightCircleFillSVG from '../../assets/icons/arrow-right-circle-fill.svg';
import type { IconProps } from '../core-icon';

export const ArrowRightCircleFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={arrowRightCircleFillSVG} {...props} />;
};
